export class TopupAmountsViewModel {
    CountryPhonePrefix: string;
    AvailableTopupOptions: Array<TopupAmountItem>;
}

export class TopupAmountItem {
    ReceivableAmount: number;
    ReceivableCurrencyCode: number;
    Pricing: Array<TopupPricing>;
}

export class TopupPricing {
    PaidAmount: number;
    PaidCurrencyCode: string;
}